import { P0, S, abs, fillAt, limb, max, quad, rotPts } from '../../geometry';

export const tulip = {
  name: 'Tulip',
  colors: ['#D6409F', '#2F9E5B'],
  draw(m, t) {
    let open = 0.2 + 0.08 * S(t * 1.3),
      head = 2 * S(t * 1.1),
      lf = 4 * S(t * 1.5),
      tall = 0,
      pose = P0();
    if (m === 'happy') {
      open = 0.7 + 0.3 * abs(S(t * 6));
      head = 6 * S(t * 6);
      lf = 14 * S(t * 9);
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: the outer petals keep slowly opening and closing, the head nodding along.
    if (m === 'thinking') {
      open = 0.5 + 0.5 * S(t * 1.6);
      head = 5 * S(t * 1.6 - 1);
      lf = 10 * S(t * 3.2);
    }
    if (m === 'talking') {
      open = 0.25 + 0.3 * max(0, S(t * 10));
    }
    if (m === 'surprised') {
      open = 1.1;
      tall = -3;
      head = S(t * 22);
    }
    if (m === 'paused') {
      open = 0;
      head = -16 + S(t * 0.7);
      lf = 20;
      pose.ty = 2;
    }
    const hp = [50, 62 + tall],
      H = (p) =>
        rotPts(
          p.map(([x, y]) => [x, y + tall]),
          hp[0],
          hp[1],
          head
        );
    const cup = H([
      [33, 30],
      ...quad([33, 30], [30, 62], [50, 62], 6).slice(1),
      ...quad([50, 62], [70, 62], [67, 30], 6).slice(1),
      [58.5, 38],
      [50, 24],
      [41.5, 38],
      [33, 30],
    ]);
    const petal = (dir) => {
      const bx = 50 + dir * 12,
        by = 60,
        a = (dir < 0 ? -112 : -68) - dir * 48 * open;
      return H([
        [bx, by],
        ...limb(bx, by, a, 30, dir * 6, 5).slice(1),
        ...limb(bx, by, a, 30, -dir * 6, 5)
          .slice(1, 4)
          .reverse(),
        [bx, by],
      ]);
    };
    const stemTop = H([[50, 62]])[0],
      stem = quad(stemTop, [50, 76], [50, 88], 4);
    const leaf = [
      [50, 84],
      ...limb(50, 84, -45 - lf, 18, 6, 4).slice(1),
      ...limb(50, 84, -45 - lf, 18, -6, 4)
        .slice(1, 3)
        .reverse(),
      [50, 84],
    ];
    const eye = H([[50, 48]])[0];
    return {
      strokes: [
        { c: 'b', pts: stem },
        { c: 'b', pts: leaf, n: 14 },
        { c: 'a', pts: petal(-1), n: 16 },
        { c: 'a', pts: petal(1), n: 16 },
        { c: 'a', pts: cup, n: 44, sharp: true },
      ],
      eyes: { x: eye[0], y: eye[1] },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 4),
};
